// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { ScrollText } from 'lucide-react'
import AuditExplorer from '../admin/AuditExplorer'

/**
 * /settings/audit — pharmacy-mode audit log page.
 *
 * Per sponsor request 2026-05-11: pharmacy admins were "blind" to who
 * was accessing what data in their pharmacy. The audit log API endpoint
 * (GET /api/audit) is already tenant-scoped (WI-899 — bound admins see
 * only events authored by their pharmacy's accounts). The page itself
 * already existed at /admin/audit but pharmacy Owners had to dig into
 * the Administration shell to find it.
 *
 * This wrapper exposes the same content under /settings/audit, with the
 * Settings-section header. D-AUDIT-2: the wrapped AuditExplorer searches on the
 * server (GET /api/audit/search) and is the same component SaaS admins get at
 * /admin/audit, where they pick one pharmacy first.
 *
 * Permission: admin.audit.read (Owners + Managers by default per
 * 016_seed_rbac_defaults; RPh/Tech/Provider do NOT have it).
 */
export default function AuditLogSettings() {
  return (
    <div style={{ maxWidth: 'var(--page-max, 1100px)', padding: '0 8px' }}>
      <header style={{ marginBottom: 20 }}>
        <h1 style={titleStyle}>
          <ScrollText size={22} style={{ verticalAlign: '-3px', marginRight: 8 }} />
          Audit log
        </h1>
        <p style={subtitleStyle}>
          Every action in your pharmacy is logged here — prescription
          opens, role changes, refill decisions, comments, and more.
          You see only events from your own pharmacy.
        </p>
      </header>
      <AuditExplorer />
    </div>
  )
}

const titleStyle: React.CSSProperties = {
  fontSize: 22, fontWeight: 600, margin: 0, color: 'var(--color-text)',
}
const subtitleStyle: React.CSSProperties = {
  fontSize: 13, color: 'var(--color-text-soft)', margin: '6px 0 0 0',
  maxWidth: '100%',
}
